export { default } from "./WaiverDetails";
